import { useState } from "react";
import { doc, updateDoc, arrayRemove, getDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import "./Button.css";

/**
 * useLinkRemover
 * - ノード間リンク削除モジュール
 */
export const useLinkRemover = (storyId, nodes) => {
  const [removeMode, setRemoveMode] = useState(false);
  const [selectedNode, setSelectedNode] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  // 選択中ノード情報を返す
  const selectedRemoveNode = nodes.find((n) => n.id === selectedNode) || null;

  const removeLinkFromFirestore = async (nodeAId, nodeBId) => {
    try {
      const nodeARef = doc(db, "stories", storyId, "nodes", nodeAId);
      const nodeBRef = doc(db, "stories", storyId, "nodes", nodeBId);

      const nodeASnap = await getDoc(nodeARef);
      const nodeBSnap = await getDoc(nodeBRef);

      if (!nodeASnap.exists() || !nodeBSnap.exists()) {
        setErrorMessage("削除対象のノードが存在しません");
        return;
      }

      const nodeAData = nodeASnap.data();
      const nodeBData = nodeBSnap.data();

      if ((nodeAData.childrenIds?.length || 0) <= 1 || (nodeBData.parentId?.length || 0) <= 1) {
        setErrorMessage("最後のリンクなので削除できません");
        return;
      }

      await updateDoc(nodeARef, { childrenIds: arrayRemove(nodeBId) });
      await updateDoc(nodeBRef, { parentId: arrayRemove(nodeAId) });

      setErrorMessage("");
      //console.log(`✅ ${nodeAId} ⇄ ${nodeBId} のリンクを削除しました`);
    } catch (error) {
      console.error(error);
      setErrorMessage("リンク削除中にエラーが発生しました");
    }
  };

  const handleNodeClick = (node) => {
    if (!removeMode) return;

    if (!selectedNode) {
      //console.log("🟢 削除モード：1つ目ノード選択", node.id);
      setSelectedNode(node.id);
      const el = document.querySelector(`[data-nodeid="${node.id}"]`);
      if (el) el.classList.add("highlight-node");
      return;
    }

    //console.log("🟢 削除モード：2つ目ノード選択", node.id);

    removeLinkFromFirestore(selectedNode, node.id);

    document.querySelectorAll(".highlight-node").forEach(el => el.classList.remove("highlight-node"));
    setSelectedNode(null);
    setRemoveMode(false);
  };

  const toggleRemoveMode = () => {
    if (removeMode) cancelRemoveMode();
    else startRemoveMode();
  };

  const startRemoveMode = () => {
    //console.log("🟢 削除モード開始");
    setSelectedNode(null);
    setRemoveMode(true);
    setErrorMessage("");
  };

  const cancelRemoveMode = () => {
    //console.log("❌ 削除モードキャンセル");
    setSelectedNode(null);
    setRemoveMode(false);
    document.querySelectorAll(".highlight-node").forEach(el => el.classList.remove("highlight-node"));
    setErrorMessage("");
  };

  return {
    removeMode,
    selectedRemoveNode, // 追加
    errorMessage,
    handleNodeClick,
    toggleRemoveMode,
  };
};
